import React from 'react';
import './MessageDetail.css';

const MessageDetail = ({ message, onClose }) => {
  return (
    <div className="message-detail">
      <div className="message-header">
        <h2>{message.subject}</h2>
        <button onClick={onClose}>Close</button>
      </div>
      <div className="message-content">
        <p>Message details coming soon...</p>
      </div>
    </div>
  );
};

export default MessageDetail; 